import angular from 'angular';

const popinCameraDirective = /* @ngInject */ (
	/** @type {import('angular').ui.bootstrap.IModalService} */ $uibModal,
) => ({
	restrict: 'A',
	require:  'ngModel',
	scope:    {
		file:   '=ngModel',
		select: '&popinCameraSelect',
	},
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {any} attributes
	 * @param {import('angular').INgModelController} modelCtrl
	 */
	link(scope, element, attributes, modelCtrl) {
		element.click(() => {
			const modalInstance = $uibModal.open({
				ariaLabelledBy:  'modal-camera-title',
				ariaDescribedBy: 'modal-camera-body',
				template:        '<camera on-cancel="cancel()" on-submit="submit(file)" ng-model="file"></camera>',
				controller:      /* @ngInject */ (
					/** @type {any} */ $scope,
					/** @type {import('angular').ui.bootstrap.IModalInstanceService} */ $uibModalInstance,
				) => {
					$scope.file = scope.file;

					$scope.submit = (/** @type {any} */ file) => {
						$uibModalInstance.close(file);
					};

					$scope.cancel = () => {
						$uibModalInstance.dismiss('cancel');
					};
				},
				windowClass:     'modal-camera',
			});

			modalInstance.result.then(file => {
				modelCtrl.$setViewValue(file);
				scope.file = file;
				return scope.select({ file: scope.file });
			}).catch(error => (error === 'cancel' ? true : console.error(error)));
		});
	},
});

// @ts-ignore
angular.module('app').directive('popinCamera', popinCameraDirective);
